<template>
  <div class="mark-dialog">
    <el-dialog
      :visible.sync="markShow"
      :title="detailInfo.matchType === 1 ? '人员标记' : '车辆标记'"
      :modal="false"
      @close="dialogClose"
      v-dialogDrag
      width="550px"
    >
      <el-scrollbar style="height: calc(100vh - 420px)">
        <div class="main-title">
          <span> {{ detailInfo.matchType === 1 ? "人员" : "车辆" }}详情</span>
        </div>
        <!-- <div class="sub-title">
         信息
        </div> -->
        <div class="info-area">
          <el-form ref="form" :model="detailInfo" label-width="90px">
            <el-form-item
              class="item-margin item-image"
              label=""
              label-width="0px"
            >
              <img
                class="stranger_img"
                :src="getImageUrl(detailInfo.fileCode)"
                @click="showViewer"
                style="width: 150px; height: 150px"
                onerror="this.src='/images/theme/newDark/default.png'"
              />
            </el-form-item>
            <el-row class="">
              <el-col :span="12">
                <el-form-item
                  class="item-margin"
                  :label="detailInfo.matchType === 1 ? '姓名：' : '车主姓名：'"
                >
                  <el-input
                    v-if="isMark && isNeedEdit"
                    v-model="markData.personName"
                  ></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.name) ||
                    detailInfo.personName ||
                    "陌生人"
                  }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="item-margin"
                  label="性别："
                  v-if="isMark && isNeedEdit"
                >
                  <el-select v-model="markData.sex" placeholder="请选择">
                    <el-option
                      v-for="item in sexOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="item-margin" label="性别：" v-else>
                  <label v-if="detailInfo.personnel !== null">{{
                    (detailInfo.personnel && detailInfo.personnel.sex)
                      | showSexType
                  }}</label>
                  <label v-else>{{ detailInfo.sex | showSexType }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item class="item-margin" label="电话：">
                  <el-input
                    v-if="isMark && isNeedEdit"
                    v-model="markData.phone"
                  ></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.phone) ||
                    detailInfo.phone ||
                    "未知"
                  }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="item-margin" label="身份证：">
                  <el-input
                    v-if="isMark && isNeedEdit"
                    v-model="markData.idCard"
                  ></el-input>
                  <label v-else>{{
                    (detailInfo.personnel && detailInfo.personnel.idCard) ||
                    detailInfo.idCard ||
                    "未知"
                  }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="item-margin"
                  v-if="detailInfo.matchType === 2"
                  label="车牌："
                >
                  <label>{{ detailInfo.plateNo }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="item-margin"
                  :label="detailInfo.matchType === 1 ? '类型：' : '车主类型：'"
                >
                  <label>{{
                    detailInfo.personnelType == 1
                      ? "员工"
                      : detailInfo.personnelType == 2
                      ? "外来人员"
                      : "陌生人"
                  }}</label>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="item-margin" label="位置：">
              <label>{{ detailInfo.areaName || "未知" }}</label>
            </el-form-item>
            <el-form-item class="item-margin" label="时间：">
              <label>{{ detailInfo.matchTime || "-" }}</label>
            </el-form-item>
          </el-form>
        </div>
        <div
          v-if="!isMark"
          class="mark-btn valign-center"
          v-auth="'/access/identifyCenter:mark'"
        >
          <el-button type="primary" @click="clickMarkBtn">标 记</el-button>
        </div>
        <div class="sub-title" v-if="isMark">类型标记</div>
        <div class="info-area" style="margin-bottom: 10px" v-if="isMark">
          <remark-handle
            ref="remarkHandle"
            :markData="markData"
            :detailInfo="detailInfo"
            :matchRecordCode="detailInfo.matchRecordCode"
            :match-type="detailInfo.matchType"
            @cancleMark="cancleMark"
            @assignTask="assignTask"
            @showTree="showTree"
            @recordMarked="recordMarkedHandle"
          ></remark-handle>
        </div>
        <viewer
          @inited="inited"
          :images="viewerPhotos"
          class="viewer"
          ref="viewer"
        >
          <img v-for="src in viewerPhotos" :src="src" :key="src" />
        </viewer>
        <assignDialog
          onlyHandAlarm
          ref="taskAssign"
          @childByValue="childByValue"
        ></assignDialog>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>
<script>
import remarkHandle from "../components/remark-handle";
import { Dic, Dates, Bus } from "$utils";
import { api } from "../api";
import assignDialog from "@src/modules/taskCenter/components/TaskAssignComponent";

export default {
  filters: {
    formartterTime(time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    showSexType(sex, item) {
      return Dic.findByValue("SENU001", Number(sex));
    },
  },
  components: {
    remarkHandle,
    assignDialog,
  },
  props: {
    // nowMatchType: {
    //   type: Number,
    //   default: () => {
    //     return 1;
    //   },
    // },
  },
  data() {
    return {
      showTreeList: false,
      markShow: false,
      detailInfo: {},
      markData: {},
      isMark: false,
      recordMarked: false,
      viewerPhotos: [],
      typeValue: "",
      sexOptions: Dic.find("SENU001"),
    };
  },
  mounted() {},
  methods: {
    openDialog(data) {
      console.log(data, "=========");
      this.detailInfo = data;
      this.markShow = true;
    },
    dialogClose() {
      this.markShow = false;
      this.isMark = false;
      this.recordMarked = false;
      this.detailInfo = {};
    },
    getImageUrl(url) {
      return url ? Bus.imgPath(url) : "";
    },
    cancleMark(hasRefresh) {
      this.isMark = false;
      this.recordMarked = false;
      // this.markShow = false;
      this.showTreeList = false;
      if (hasRefresh) {
        this.$emit("queryMatchRecord");
      }
    },
    showViewer(e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    clickMarkBtn() {
      this.isMark = true;
      if (
        (this.detailInfo.personnel &&
          this.detailInfo.personnel.name !== null) ||
        this.detailInfo.personName !== null
      ) {
        this.isNeedEdit = false;
      } else {
        this.isNeedEdit = true;
      }
    },
    closeTree() {
      this.showTreeList = false;
    },
    showTree() {
      this.$emit("showTree");
    },
    recordMarkedHandle(val) {
      this.recordMarked = val;
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    assignTask() {
      this.$refs.taskAssign.open();
    },
    childByValue(taskAssignInfo) {
      let url = api.addTaskInfo;
      this.$fetch(url, taskAssignInfo).then((res) => {
        if (res.success) {
          // 任务下发成功：关闭下发任务弹窗、关闭右侧详情面板、刷新左侧列表页面
          this.$refs.taskAssign.close();
          // 关闭右侧详情面板同时刷新左侧列表页面
          this.cancleMark(true);
          this.$message({
            message:
              (this.isEdit
                ? this.$t("taskCenter.label.modify")
                : this.$t("taskCenter.label.add")) +
              this.$t("taskCenter.label.success"),
            type: "success",
          });
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.mark-btn {
  justify-content: center;
}
.item-image {
  display: flex;
  justify-content: space-around;
}
</style>
